import React from 'react';
import PropTypes from 'prop-types';

import Link from '@mui/material/Link';

import { PRIMARY_COLOR } from '../../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../../theme/fontConstants';

const TEN_DIGITS = /^\d{10}$/;

const formatEmployeePhoneNumber = (phoneNumber) => {
  if (typeof phoneNumber !== 'string' || phoneNumber.length === 0) {
    return '';
  }

  if (TEN_DIGITS.test(phoneNumber)) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6)}`;
  }

  return phoneNumber;
};

const EmployeePhoneLink = ({ phoneNumber }) => {
  const display = formatEmployeePhoneNumber(phoneNumber);
  if (!display) return null;

  return (
    <Link
      href={`tel:${phoneNumber}`}
      data-testid="employee-phone-number"
      underline="hover"
      sx={{
        color: PRIMARY_COLOR[70],
        fontFamily: PRIMARY_FONT[500],
        fontSize: '12px',
        lineHeight: '14px',
        whiteSpace: 'nowrap',
      }}
    >
      {display}
    </Link>
  );
};

EmployeePhoneLink.propTypes = {
  phoneNumber: PropTypes.string,
};

export default EmployeePhoneLink;
